import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

interface AleaVielIconProps extends IconProps {
  color?: string;
}

export const AleaVielIcon: React.FC<AleaVielIconProps> = ({ 
  color = '#2B4956', 
  ...props 
}) => {
  return (
    <Icon
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path 
        d="M36.4945 29.5674C36.4945 35.6574 31.5445 40.5874 25.4445 40.5874C19.3445 40.5874 14.3945 35.6474 14.3945 29.5674C14.3945 23.4874 25.4445 9.60742 25.4445 9.60742C25.4445 9.60742 36.4945 23.4774 36.4945 29.5674Z" 
        fill="white" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M19.1145 19.4375C16.6445 23.3675 14.3945 26.8275 14.3945 29.5675C14.3945 35.6575 19.3445 40.5875 25.4445 40.5875C31.5445 40.5875 36.4945 35.6475 36.4945 29.5675C36.4945 26.8175 34.2445 23.3575 31.7745 19.4375H19.1145Z" 
        fill="#ED9A37"
      />
      <path 
        d="M36.4945 29.5674C36.4945 35.6574 31.5445 40.5874 25.4445 40.5874C19.3445 40.5874 14.3945 35.6474 14.3945 29.5674C14.3945 23.4874 25.4445 9.60742 25.4445 9.60742C25.4445 9.60742 36.4945 23.4774 36.4945 29.5674Z" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default AleaVielIcon; 